import { RouteObject } from "react-router-dom";

const VaultSettingsRoute: RouteObject[] = [
    {
        path: "coffre",
        async lazy() {
            const { VaultTotpSettings } = await import("@/pages/settings/vault/totp");
            return { Component: VaultTotpSettings };
        },
    },
    {
        path: "coffre/audit",
        async lazy() {
            const { VaultAuditSettings } = await import("@/pages/settings/vault/audit");
            return { Component: VaultAuditSettings };
        },
    },
];

export default VaultSettingsRoute;
